import { LabeledData, useMoment } from '@gorila-shared-ui/components';
import { WS_TYPE } from '../../constants/webService';
import { WebServiceLog } from '../../types/webServiceLogs';
import { CodeBlock } from '../shared/CodeBlock';

type Props = {
  webService: WebServiceLog;
};
export function WebServiceLogInfo({ webService }: Readonly<Props>) {
  const { formatDateFromTs } = useMoment();
  return (
    <>
      <LabeledData
        labelWidth="80px"
        label="Tipo:"
        content={WS_TYPE[webService.wsType]}
      />
      <CodeBlock
        label="Activo:"
        code={webService.asset}
      />
      <CodeBlock
        label="Data:"
        code={webService.data}
      />
      <CodeBlock
        label="Response:"
        code={webService.response}
      />
      <LabeledData
        labelWidth="190px"
        label="Fecha de creación:"
        content={formatDateFromTs(+webService.created)}
      />
    </>
  );
}
